import React, { useEffect, useState } from "react";
import { CreditCard, X, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";

export function StaffAlertsBanner() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/staff-alerts").then((r) => setRows(r.data.rows || [])).catch(() => setRows([])); }, []);
  const dismiss = async (id) => {
    setRows((x) => x.filter((a) => a.id !== id));
    try { await api.post(`/staff-alerts/${id}/dismiss`); } catch (e) { console.warn("Uyarı kapatılamadı", e); }
  };
  if (!rows.length) return null;
  return (
    <div className="max-w-[1600px] mx-auto px-6 pt-3 space-y-2">
      {rows.map((a) => (
        <div key={a.id} data-testid={`staff-alert-${a.kind}`} className="bg-sky-50 border border-sky-200 rounded-xl px-4 py-2.5 text-sm text-sky-900">
          <div className="flex items-center gap-2">
            <CreditCard size={16} className="text-sky-600 shrink-0" />
            <span className="font-semibold">{a.title}</span>
            <span className="hidden md:inline text-xs text-sky-700">· {a.message}</span>
            <button type="button" onClick={() => setOpen((v) => !v)} data-testid="staff-alert-toggle"
              className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-sky-700 hover:text-sky-900">
              {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />} Liste
            </button>
            <button type="button" onClick={() => dismiss(a.id)} data-testid="staff-alert-dismiss" title="Uyarıyı kapat"
              className="p-1 rounded hover:bg-sky-100 text-sky-700"><X size={14} /></button>
          </div>
          {open && (
            <div className="mt-2 flex flex-wrap gap-1.5" data-testid="staff-alert-people">
              {a.people.map((p) => (
                <span key={p.id} className="text-[11px] bg-white border border-sky-200 rounded px-2 py-0.5">{p.ad_soyad} · {p.sicil_no}</span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
